// To be reused in components/stores to check if the user has a specific role
const hasRole = (profile, roleName) => profile?.roles?.some(role => role.name === roleName);

export const isRole = (profile) => ({
    superAdmin: () => hasRole(profile, 'super_admin'),
    systemAdmin: () => hasRole(profile, 'system_admin'),
    labStaff: () => hasRole(profile, 'lab_staff'),
    labAdmin: () => hasRole(profile, 'lab_admin'),
    pharmacyStaff: () => hasRole(profile, 'pharmacy_staff'),
    pharmacyAdmin: () => hasRole(profile, 'pharmacy_admin'),
});
